import { MUIChip } from "@abb/arcadia-ui-react"
import type { ComponentProps } from "react"
import { ApplicationPermissionStatus } from "../models/ApplicationPermissionUser"
import { ApplicationRoleStatus } from "../models/ApplicationRoleUser"
import { TrainingUserStatus } from "../models/TrainingUser"

type ChipProps = ComponentProps<typeof MUIChip>

export function getUserApplicationStatusProps(
  status: ApplicationPermissionStatus | ApplicationRoleStatus | TrainingUserStatus
): ChipProps {
  let props: ChipProps = {
    label: status,
    size: 32,
  }

  switch (status.toLowerCase()) {
    case "active":
    case "valid":
      props = { ...props, leadingIconName: "icon_abb_dias icon-abb_completed-check" }
      break
    case "planned":
      props = { ...props, leadingIconName: "icon_abb_dias icon-abb_time-clock" }
      break
    case "expired":
      props = { ...props, leadingIconName: "icon_abb_dias icon-abb_cancel-circle" }
      break
    case "disabled":
      props = { ...props, leadingIconName: "icon_abb_dias icon-abb_stop" }
      break
    default:
      break
  }

  return props
}
